<div class="filtro-busca-wrapper">
  <input
    type="text"
    [ngModel]="value"
    (ngModelChange)="onChange($event)"
    (keyup.enter)="onBuscar()"
    [placeholder]="placeholder"
    [disabled]="disabled"
  />
  <button
    type="button"
    class="btn-buscar"
    title="Buscar"
    [disabled]="disabled"
    (click)="onBuscar()"
  >
    <mat-icon class="icone-busca">search</mat-icon>
  </button>
</div>
